export const SageLoginCodePhoneNumberProd = '+18667775871';
export const SageLoginCodePhoneNumberDev = '+18667775872';
